import graphql__57ce32a3dafbf548095f from "./__generated__/AddContactToMailingListDialogContactsQuery.graphql.ts";
import graphql__38d4f294dd283a835447 from "./__generated__/AddContactToMailingListDialogMutation.graphql.ts";import * as React from "react";
import {graphql, fetchQuery} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import {useRelayEnvironment} from "react-relay/hooks";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import asFormikField from "../abstract/asFormikField";
import AbstractCombobox from "../abstract/AbstractCombobox";

type Props = {
    mailingListIdentifier: string;
    mailingListId: string;
    handleCloseDialog: () => void;
}

const contactsDataProvider = (relayEnvironment) => {
    return AwesomeDebouncePromise((searchTerm: string = '') => {
        return fetchQuery(relayEnvironment, graphql__57ce32a3dafbf548095f, {searchTerm}).toPromise().then((data) => {
            if (!data) {
                return [];
            }
            //@ts-ignore
            return data.contacts?.edges?.map((edge) => edge.node) || [];
        });
    }, 500);
}

const getContactLabel = (contact) => {
    if (!contact) return '';
    if (contact.__typename === 'TeamContact') {
        return contact.teamName || '';
    }
    return [contact.givenName, contact.familyName].filter(Boolean).join(' ') || '';
};

const getContactSecondaryLabel = (contact) => {
    if (!contact) return '';
    return contact.emailAddress || '';
};

const AddContactToMailingListDialog: React.FC<Props> = ({mailingListIdentifier, mailingListId, handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (values) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__38d4f294dd283a835447,
                variables: {
                    input: {
                        mailingListIdentifier: mailingListIdentifier,
                        contactIdentifier: values.contact?.contactIdentifier || null
                    }
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    handleCloseDialog();
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToSubscribeToList'})
            }
        )
    }

    const initialValues = {
        contact: null
    }

    const validationSchema = yup.object().shape({
        contact: yup.object()
            .required(intl.formatMessage({id: 'validation.field.required'})),
    });

    const ContactCombobox = asFormikField(AbstractCombobox, 'contact');

    return (
        <FormDialog handleCloseDialog={handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    headline={intl.formatMessage({id: 'dialog.AddContactToMailingListDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.add'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.AddContactToMailingListDialog.contactLabel'})}</Label>
                    <ContactCombobox
                        getEntryId={(contact) => contact.contactIdentifier}
                        getEntryLabel={getContactLabel}
                        getEntrySecondaryLabel={getContactSecondaryLabel}
                        dataProvider={contactsDataProvider(relayEnvironment)}
                        placeholder={intl.formatMessage({id: 'dialog.AddContactToMailingListDialog.contactPlaceholder'})}
                    />
                </Row>
            </Section>
        </FormDialog>
    )
}

export default AddContactToMailingListDialog;
